import { motion } from "framer-motion";
import { ArrowUpRight, Lightbulb, Coins, Users, MapPin } from "lucide-react";
import { scrollTo } from "./Navbar";

const PARIS_IMG =
  "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const icons = { solutions: Lightbulb, budget: Coins, talents: Users, scouting: MapPin };

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export const ExecProductionSection = ({ t }) => (
  <section id="production-executive" className="py-24 sm:py-32 lg:py-40 bg-surface grain relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
      <motion.div {...reveal} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center mb-16">
        <div className="lg:col-span-6">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brass mb-6">{t.exec.overline}</p>
          <h2 data-testid="chapter-03-title" className="font-serif text-4xl sm:text-6xl tracking-tight leading-[1.05] text-ink">
            {t.exec.title}
          </h2>
          <p className="text-base sm:text-lg text-ink2 leading-relaxed mt-6 max-w-xl">{t.exec.body}</p>
          <button
            data-testid="exec-section-cta"
            onClick={() => scrollTo("#contact")}
            className="group mt-9 inline-flex items-center gap-2 bg-ink text-paper px-7 py-3.5 rounded-full text-sm font-medium tracking-wide hover:bg-brass transition-colors duration-300"
          >
            {t.exec.cta}
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
        <div className="lg:col-span-6">
          <div className="img-frame rounded-sm aspect-[16/11] shadow-2xl">
            <img src={PARIS_IMG} alt={t.exec.imgAlt} className="w-full h-full object-cover" />
          </div>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {t.exec.points.map((p, i) => {
          const Icon = icons[p.id];
          return (
            <motion.div
              key={p.id}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.06 }}
              data-testid={`exec-point-${p.id}`}
              className="bg-cardbg border border-line rounded-sm p-6 hover:border-brass transition-colors duration-300"
            >
              <Icon size={20} className="text-brass mb-5" />
              <h3 className="font-serif text-xl sm:text-2xl tracking-tight text-ink mb-3">{p.title}</h3>
              <p className="text-sm text-ink2 leading-relaxed">{p.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
